import React from 'react';
import { connect } from 'react-redux';
import Notification from 'react-web-notification/lib/components/Notification'

window.React = React;

class BrowserNotification extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            ignore: true,
        };
    }

    handlePermissionGranted() {
        // console.log('Notification Permission Granted');
        this.setState({ ignore: false });
    }
    handlePermissionDenied() {
        console.log('Notification Permission Denied');
        this.setState({ ignore: true });
    }
    handleNotSupported() {
        console.log('Web Notification not Supported');
        this.setState({
            ignore: true
        });
    }

    handleNotificationOnClick(e, tag) {
        // console.log(e, 'Notification clicked tag:' + tag);
    }

    handleNotificationOnError(e, tag) {
        // console.log(e, 'Notification error tag:' + tag);
    }

    handleNotificationOnClose(e, tag) {
        // console.log(e, 'Notification closed tag:' + tag);
    }

    handleNotificationOnShow(e, tag) {
        // console.log(e, 'Notification shown tag:' + tag);
    }

    render() {
        let { title, options } = this.props.notification;

        return (
            <Notification
                ignore={this.state.ignore && title !== ''}
                notSupported={this.handleNotSupported.bind(this)}
                onPermissionGranted={this.handlePermissionGranted.bind(this)}
                onPermissionDenied={this.handlePermissionDenied.bind(this)}
                onShow={this.handleNotificationOnShow.bind(this)}
                onClick={this.handleNotificationOnClick.bind(this)}
                onClose={this.handleNotificationOnClose.bind(this)}
                onError={this.handleNotificationOnError.bind(this)}
                timeout={5000}
                title={title}
                options={options}
            />
        )
    }
};
const mapStateToProps = ({ notification }) => {
    return {
        notification: notification.notification,
    };
};
export default connect(mapStateToProps)(BrowserNotification);